import { useEffect } from 'react';

type ImageLightboxProps = {
  open: boolean;
  src: string;
  caption: string;
  onClose: () => void;
};

const ImageLightbox = ({ open, src, caption, onClose }: ImageLightboxProps) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/90 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="高清剧照预览"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="关闭预览"
        className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-background-50/30 text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300"
      >
        <i className="ri-close-line text-2xl" />
      </button>
      <figure
        className="w-full max-w-5xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex justify-center">
          <img
            src={src}
            alt={caption}
            title={caption}
            className="max-h-[78vh] w-auto max-w-full rounded-lg object-contain"
          />
        </div>
        <figcaption className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-background-200">
          {caption}
        </figcaption>
      </figure>
    </div>
  );
};

export default ImageLightbox;